module.exports = __webpack_public_path__ + "static/img/20006 (3).6307163.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20006 (3).webp
// module id = mumq
// module chunks = 14